import React, {useEffect} from 'react'
import {Checkbox as MuiCheckbox, FormHelperText, withStyles} from '@material-ui/core';
import PropTypes from 'prop-types';
import GridBlock from 'components/GridBlock';
import Tr from 'translations/Translations';
import SimpleTable from 'components/complex/simpleTable/SimpleTable';
import Checkbox from 'components/Checkbox';
import getObjectValue from 'libs/getObjectValue';
import clsx from "clsx";
import TextInput from "components/TextInput";


const style = theme => ({
    root: {
        marginBottom: theme.spacing(2)
    },
    textBold: {
        fontWeight: theme.typography.fontWeightBold,
    },
    samllColumn: theme.components.table.lpColumn,
    orderColumn: theme.components.table.ipColumn,
    checkboxColumn: {
        width: theme.spacing()
    },
    cells: {
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
    },
    checkbox: {
        padding: 0,
    },
    cursor: {
        cursor: "pointer"
    },
    hidden: {
        display: 'none'
    }
})

let typingStopTimeout = null;

function PartsTable(
    {
        classes,
        className,
        formikProps,
        id,
        elementList = [],
        label,
        editable = true,
        required=true,
        disabled
    }) {
    const elements = getObjectValue(id, formikProps.values, []);
    const errorValue = getObjectValue(id, formikProps.errors, '');
    const touched = getObjectValue(id, formikProps.touched, false);
    const isAllChecked = elementList.length > 0 && !elementList.find(x => elements[x.identity] !== true);

    const search = formikProps.values.search;

    const handleHeadCheckboxChange = (e, value) => {
        const newElements = elementList.reduce((acc, x) => {
            return {
                ...acc,
                [x.identity]: value
            }
        }, {})
        formikProps.setFieldValue(id, newElements)
    }

    useEffect(() => {
        clearTimeout(typingStopTimeout);
        typingStopTimeout = setTimeout(() => {
            if (!search || search === '') {
                formikProps.setFieldValue('hidden', []);
            } else {
                const elementsToHide = [];
                elementList.forEach(e => {
                    if (e.firstName.toLowerCase().includes(search.toLowerCase())
                        || e.lastName.toLowerCase().includes(search.toLowerCase())
                        || e.email.toLowerCase().includes(search.toLowerCase())) {
                    } else {
                        elementsToHide.push(e.identity);
                    }
                });
                formikProps.setFieldValue('hidden', elementsToHide);
            }
        }, 500);
        return () => {
            clearTimeout(typingStopTimeout);
        }
        // eslint-disable-next-line
    }, [search])

    const isError = editable && !!errorValue && Boolean(touched);
    const helperText = errorValue || ' ';
    return (
        <GridBlock
            className={clsx(classes.root, className)}
            column
        >
            <TextInput
                label={Tr('search_label_5')}
                id='search'
                formikProps={formikProps}
            />
            <SimpleTable
                headers={[
                    <MuiCheckbox
                        color='primary'
                        className={classes.checkbox}
                        onChange={handleHeadCheckboxChange}
                        checked={isAllChecked}
                        disabled={disabled}
                    />,
                    Tr('column_lp'),
                    Tr('user')
                ]}
                items={elementList.filter(x => !formikProps.values.hidden.includes(x.identity)).map((x, i) => {
                    return [
                        <Checkbox
                            id={`${id}.${x.identity}`}
                            formikProps={formikProps}
                            checkboxClassName={classes.checkbox}
                            htmlId={`${id}.${x.identity}`}
                            disabled={disabled}
                        />,
                        <label className={classes.cursor} htmlFor={`${id}.${x.identity}`}>{i + 1}</label>,
                        <label className={classes.cursor} htmlFor={`${id}.${x.identity}`}>{x.firstName} {x.lastName} ({x.email})</label>,
                    ]
                })}
                cellClassName={classes.cells}
                columnClasses={[
                    classes.checkboxColumn,
                    classes.samllColumn
                ]}
            />
            {isError && <FormHelperText error>{helperText}</FormHelperText>}
        </GridBlock>
    )
}

PartsTable.propTypes = {
    classes: PropTypes.any,
}

export default withStyles(style)(PartsTable);
